// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1591":"5452b270056701ee","2101":"bc38be3a3a2ccded","8872":"2298a2981ad0bef9"}[chunkId] + ".css";
};